import useOrdersContext from 'contexts/orders.context';
import React from 'react';
import { getCountdownFromSeconds, openingTime } from 'utils/functions';

type Props = {
  image: string | undefined;
  logo: string | undefined;
  isBusy: boolean;
  reactivationTime: number | undefined;
  isBrandOpen: boolean;
};

const RestaurantHeader = ({ image, logo, isBusy, reactivationTime, isBrandOpen }: Props) => {
  const { restaurant } = useOrdersContext();
  return (
    <div className='w-full h-auto'>
      <div className='relative'>
        <img
          src={image}
          className={`w-full aspect-[1/0.25] object-cover  ${
            !isBrandOpen || isBusy ? 'brightness-[30%]' : ''
          }`}
        />
        {isBusy && reactivationTime && (
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            <p className='font-medium text-2xl text-white text-center'>Busy</p>
            <p className='text-white text-center'>
              Back in {getCountdownFromSeconds(reactivationTime)}
            </p>
          </div>
        )}
        {!isBrandOpen && (
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            <p className='font-medium text-2xl text-white text-center'>Closed</p>
            <p className='text-white text-center'>
              Opens {restaurant ? openingTime(restaurant) : null}
            </p>
          </div>
        )}
      </div>
      <div className='relative w-full px-2 sm:px-3'>
        <div className='w-[80px] h-[80px] absolute bottom-[-40px] sm:left-3 lg:left-10 left-2 flex justify-center items-center rounded-full bg-white'>
          <img src={logo} className='w-[68px] h-[68px] object-cover rounded-full' />
        </div>
      </div>
    </div>
  );
};

export default RestaurantHeader;
